import en from '~/locals/en.json'
import ar from '~/locals/ar.json'

export const resources = {
  en,
  ar,
} as const

export type Locale = keyof typeof resources

export const DEFAULT_LOCALE: Locale = 'en'

export const RTL_LOCALES: Locale[] = ['ar']
